





















































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import Loader from "../../externals/components/Loader.vue";
import AllApplicantsTable from "../components/AllApplicantsTable.vue";
import ApprovedApplicantsTable from "../components/ApprovedApplicantsTable.vue";
import RejectedApplicantsTable from "../components/RejectedApplicantsTable.vue";
import { Applicant, FetchPayload } from "../types";
import PendingApplicantsTable from "./PendingApplicantsTable.vue";

const Applicants = namespace("applicant");

@Component({
  components: {
    loader: Loader,
    "all-applicants-table": AllApplicantsTable,
    "approved-applicants-table": ApprovedApplicantsTable,
    "rejected-applicants-table": RejectedApplicantsTable,
    "pending-applicants-table": PendingApplicantsTable,
  },
})
export default class ApplicantsTable extends Vue {
  @Applicants.Action("fetchApplicants") fetchApplicants!: (
    payload: FetchPayload
  ) => Promise<{}>;
  @Applicants.Action("viewAllApproved") viewAllApproved: () => void;
  @Applicants.Action("viewAllRejected") viewAllRejected: () => void;
  @Applicants.Action("viewAllPending") viewAllPending: () => void;
  @Applicants.Action("viewAllApplicants") viewAllAppliants: () => void;
  @Applicants.Action("setQuery") setQuery: (query: string) => void;
  @Applicants.Action("downloadApplicants") downloadApplicants: (
    payload: FetchPayload
  ) => void;
  @Applicants.Getter("allApplicants") applicants: Applicant[];
  @Applicants.Getter("allApprovedApplicants")
  allApprovedApplicants: Applicant[];
  @Applicants.Getter("allRejectedApplicants")
  allRejectedApplicants: Applicant[];
  @Applicants.Getter("allPendingApplicants")
  allPendingApplicants: Applicant[];
  @Applicants.Getter("isViewing") isViewing: string;
  @Applicants.Getter("query") query: string;

  hasApplicantError = false;
  applicantError = "";
  loading = false;

  constructor() {
    super();
  }

  async searchForApplicants(e) {
    if (e.keyCode === 13) {
      this.setQuery(e.target.value);
      //Fetch All
      try {
        await this.fetch();
      } catch (err) {
        this.hasApplicantError = true;
        this.applicantError = err.message;
      }
    }
  }

  async fetch() {
    //Fetch All
    this.fetchApplicants({ status: "all" }).catch((err) => {
      this.hasApplicantError = true;
      this.applicantError = err.message;
    });
    //Fetch All Approved
    this.fetchApplicants({ status: "approved" }).catch((err) => {
      this.hasApplicantError = true;
      this.applicantError = err.message;
    });
    //Fetch All Rejected
    this.fetchApplicants({ status: "rejected" }).catch((err) => {
      this.hasApplicantError = true;
      this.applicantError = err.message;
    });
    //Fetch All Pending
    this.fetchApplicants({ status: "new" }).catch((err) => {
      this.hasApplicantError = true;
      this.applicantError = err.message;
    });
  }

  async beforeMount() {
    //Fetch All
    await this.fetch();
  }

  fetchAllApplicants() {
    this.viewAllAppliants();
  }
  fetchApprovedApplicants() {
    this.viewAllApproved();
  }
  fetchRejectedApplicants() {
    this.viewAllRejected();
  }
  fetchPendingApplicants() {
    this.viewAllPending();
  }

  downloadApplicantsData(e) {
    e.preventDefault();

    this.downloadApplicants({ status: this.isViewing });
  }
}
